import { routeCreator } from '@adrias-online/steiner';
import _ from 'lodash';

import helper from '../../../helpers/steinerHelper';
import routeRegister from '../../../helpers/routeRegister';
import { selectors } from '../reducers/dipendenti';

const routes = helper.generateRoutes('dipendenti', selectors);
const list = _.values(routes.list).map(route => ({
    ...route,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'dipendenti' */ `modules/dipendenti/${route.componentPath}`)
                .then(response => resolve(response.default));
        });
    },
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('dipendenti', routes.patterns);
routeRegister.addLinks('dipendenti', links);

export default list;